// ViewRows.js

export const CATCH_ALL_VIEW_ID = 'all';
export const VIEW_CREATED_FROM = Object.freeze({
  DASHBOARD: 'DASHBOARD',
  NODE: 'NODE',
  DATABASE: 'DATABASE',
  PAGE: 'PAGE',
  LAYOUT: 'LAYOUT',
});

export function getViewRowKey(view) {
  return String(view?.key || '').trim();
}

export function getViewRowIdentity(view) {
  return String(view?.key || view?.id || '').trim();
}

export function getViewRowTitle(view) {
  const title = String(view?.title || '').trim();
  return title || 'Untitled View';
}

export function getViewRowCreatedFrom(view) {
  return String(view?.createdFrom || '').trim().toUpperCase();
}

export function isDashboardCreatedView(view) {
  return getViewRowCreatedFrom(view) === VIEW_CREATED_FROM.DASHBOARD;
}

export function isNodeOrDatabaseCreatedView(view) {
  return isReusableCreatedView(view);
}

export function isReusableCreatedView(view) {
  const createdFrom = getViewRowCreatedFrom(view);
  if (!createdFrom) return true;
  return createdFrom === VIEW_CREATED_FROM.NODE
    || createdFrom === VIEW_CREATED_FROM.DATABASE
    || createdFrom === VIEW_CREATED_FROM.PAGE
    || createdFrom === VIEW_CREATED_FROM.LAYOUT;
}

export function getViewRowNodeTypeKey(view) {
  return String(view?.nodeType || '').trim();
}

export function isCatchAllView(view) {
  if (!view) return false;
  if (view?.catchAll === true) return true;
  return getViewRowIdentity(view).toLowerCase() === CATCH_ALL_VIEW_ID;
}

export function isCatchAllTableView(view) {
  const type = String(view?.type || '').trim().toUpperCase();
  return type === 'TABLE' && isCatchAllView(view);
}

export function resolveParentNodeTypeLabel(parentNodeTypeLabel, fallback = 'Project') {
  const trimmed = typeof parentNodeTypeLabel === 'string' ? parentNodeTypeLabel.trim() : '';
  return trimmed || fallback;
}

export function buildRemoveFromParentLabel(parentNodeTypeLabel, fallback = 'Project') {
  return `Remove from ${resolveParentNodeTypeLabel(parentNodeTypeLabel, fallback)}`;
}

export function buildDetachEdgeLabel({
  childNodeTypeLabel,
  parentNodeTypeLabel,
  childFallback = 'Item',
  parentFallback = 'Project',
}) {
  const childLabel = String(childNodeTypeLabel || '').trim() || childFallback;
  const parentLabel = resolveParentNodeTypeLabel(parentNodeTypeLabel, parentFallback);
  return `Disconnect this ${childLabel} from this ${parentLabel}`;
}

export function toPluralLabel(label) {
  const text = String(label || '').trim();
  if (!text) return 'Items';
  return text;
}

export function buildViewDisplayTitle({
  viewTitle,
  typeLabel,
  isNodeHome = false,
}) {
  const cleanTitle = String(viewTitle || '').trim() || 'Untitled View';
  if (isNodeHome) return cleanTitle;

  const prefix = toPluralLabel(typeLabel);
  const normalizedPrefix = String(prefix || '').trim().toLowerCase();
  const normalizedTitle = cleanTitle.toLowerCase();
  const isRedundant = normalizedPrefix && normalizedPrefix === normalizedTitle;

  return isRedundant ? prefix : `${prefix} - ${cleanTitle}`;
}

export function normalizeTemplateViewRow(view) {
  return {
    key: String(view?.key || '').trim(),
    title: getViewRowTitle(view),
    type: String(view?.type || 'VIEW').trim(),
  };
}